<template>
  <div class="loading-screen">
    <span class="fbc-spinner"></span>
  </div>
</template>

<script></script>

<style scoped>
.loading-screen {
  padding-top: 20rem;
  position: fixed;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  opacity: 0.7;
  width: 100%;
  height: 100vh;
  z-index: 999;
}
</style>
